///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridCellDirective } from './grid-cell.directive';
import { GridHeaderDirective } from './grid-header.directive';
import { GridRowDirective } from './grid-row.directive';
import { GridActionsCellDirective } from './grid-actions-cell.directive';
import { GirdEmptyBlockDirective } from './gird-empty-block.directive';
import { GirdPaginationDirective } from './grid-pagination.directive';
import { GirdTitleDirective } from './gird-title.directive';
import { GridStripedRowsDirective } from './grid-striped-rows.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [
        GridCellDirective,
        GridHeaderDirective,
        GridRowDirective,
        GridActionsCellDirective,
        GirdEmptyBlockDirective,
        GirdPaginationDirective,
        GirdTitleDirective,
        GridStripedRowsDirective
    ],
    exports: [
        GridCellDirective,
        GridHeaderDirective,
        GridRowDirective,
        GridActionsCellDirective,
        GirdEmptyBlockDirective,
        GirdPaginationDirective,
        GirdTitleDirective,
        GridStripedRowsDirective
    ]
})
export class GridDirectivesModule {}
